
export class FormFieldRegistrationRelations {
  public registrationId: string;
  public registrationName: string;
  public registrationShortName: string;
  public formFieldId: string;
  public fieldKey: string;
  public formFieldLabel: string;
  public formFieldRegistrationId: string;
  public formLabel: string;
  public formFieldHasRegistration: boolean;
}
